import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import SampleProfiles from '../components/home/SampleProfiles';

const BrowsePage = () => {
  return (
    <div className="py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 mb-10">
        <h1 className="font-heading font-bold text-2xl sm:text-3xl text-white mb-2">
          Hire a Friend
        </h1>
        <p className="text-slate-400 mb-6">
          Browse and hire the right friend for your mood or need. Filter by gender, age, location,
          language, and type of friend.
        </p>
          <div className="p-6 rounded-3xl bg-slate-800/50 border border-brand-pink/30 flex flex-wrap items-center justify-between gap-6">
            <p className="text-slate-200">
              Want to view more? Unlock full access for <span className="font-bold text-white">₹2,500</span>
            </p>
            <Link
              to="/payment"
              className="flex items-center gap-2 px-6 py-3 rounded-2xl bg-brand-pink text-white font-bold hover:bg-brand-pink-dark transition-all shadow-lg shadow-brand-pink/20"
            >
              <Lock className="h-4 w-4" />
              Unlock for ₹2500
            </Link>
          </div>
      </div>
      <SampleProfiles />
    </div>
  );
};

export default BrowsePage;
